import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './ContactlessPickupLayout.styles';
import { KioskFooter, KioskHeader, KioskIdelScreen } from '..';
import ContactlessPickupForm from './ContactlessPickupForm';

export class ContactlessPickupLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.container)}>
        <KioskHeader />
        <ContactlessPickupForm />
        <KioskFooter customFooterBottom="0%" isLanguageBarAllowd={true} />
        <KioskIdelScreen />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ContactlessPickupLayout);
